/**
 * All "My shipment" table columns. Each column has an `id` (used as a key and for
 * sorting), `label` (the header column text), `width` (how wide the column should
 * be in pixels), and `alignment` (which side the column's content "sticks" to).
 */

const incomingScipForecastsShipmentsTableColumns = [
    
    {
      id: "date",
      label: "Date",
      width: 95,
      alignment: "center",
    },
    {
        id: "loadType",
        label: "IB Type",
        width: 95,
        alignment: "center",
    },
    {
      id: "tempZone",
      label: "Temp Zone",
      width: 95,
      alignment: "center",
    },
    {
      id: "forecast",
      label: "SCIP Forecast",
      width: 95,
      alignment: "center",
    },
    {
      id: "scheduled",
      label: "Scheduled",
      width: 95,
      alignment: "center",
    },
    {
      id: "unscheduled",
      label: "Pending/Missing Appointment",
      width: 95,
      alignment: "center",
    },
    {
      id: "dockReceived",
      label: "Dock Received",
      width: 95,
      alignment: "center",
    },
    ]
    
    export const defaultIncomingScipForecastsShipmentsTableColumns = incomingScipForecastsShipmentsTableColumns.reduce(
      (columns, column) => ({
        ...columns,
        [column.id]: true,
      }),
      {}
    )
    
    export const getIncomingShipmentsTableColumnById = id =>
      incomingScipForecastsShipmentsTableColumns.find(column => column.id === id)
    
    export default incomingScipForecastsShipmentsTableColumns
